import React from 'react';

export const KateInteriorsLogo: React.FC = () => (
  <div style={{ height: '210px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <img
      src="/images/logos/kate-interiors-logo.png"
      alt="Kate Interiors"
      width={300}
      height={210}
      className="dark:hidden"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
    <img
      src="/images/logos/kate-interiors-logo-dark.png"
      alt="Kate Interiors"
      width={300}
      height={210}
      className="hidden dark:block"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
  </div>
);
